<template>
    <div id="footer-template" class="footer">
        <div class="container-fixed">
            <div class="row">
                <div class="col-sm-3 offset-md-1">
                    <header>{{ 'FOOTER.MISSION' | translate }}</header>
                    <p>{{ 'FOOTER.MISSION_TEXT' | translate }}</p>
                    <div class="mt-3 mb-3">
                        <a href="mailto:0xbattleblocks@gmail.com" target="_blank">{{ 'FOOTER.EMAIL_TEXT' | translate }}</a>
                    </div>
                </div>
                <div class="col-sm-3 offset-md-1">
                    <header>{{ 'FOOTER.USEFUL_LINKS' | translate }}</header>
                    
                    <ul class="horizontal-list">   
                        <li><router-link to="/browse">Browse</router-link></li>
                        <li>DEX (in development)</li> 
                        <li>Battleground (in development)</li>   
                        <li><router-link to="/terms">{{ 'FOOTER.TERMS_OF_USE' | translate }}</router-link></li>
                    </ul>
                </div>
                <div class="col-sm-3">
                    <header>{{ 'FOOTER.CONTRACT' | translate }}</header>
                    <div class="donation-address">
                    <a :href="contractAddressUrl" target="_blank">{{ contractAddress }}</a>
                    </div>

                    <header>Other Prducts</header>
                    <div>
                        <a href="https://battleblocks.xyz" target="_blank">
                            BattleBlocks
                        </a>
                        | Dojo-X (in development)
                    </div>
                </div>
            </div>
        </div>
        <div class="copyright">
            NFT Foundation &copy; {{ thisYear }}
        </div>
    </div>
</template>

<script type="text/javascript">
import { contractAddress } from "../../util/nebulas";

  export default {
    name: 'the-footer',
    computed: {
        thisYear () {
          return new Date().getFullYear();
        },
        contractAddress () {
            return contractAddress;
        },
        contractAddressUrl () {
            return 'https://explorer.nebulas.io/#/address/' + contractAddress;
        }
    }
  }
</script>

<style scoped lang="less">
@backgroundColor: #3c3f44;
@accentColor: #fff;

.footer {
    border-top: 2px solid #000;
    background: @backgroundColor;
    width: 100%;
    padding-top: 50px;
    color: @accentColor;
    font-size: 14px;
    overflow-x: hidden;

    header {
        color: @accentColor;
        font-weight: bold;
        margin-bottom: 5px;
    }

    a {
        color: @accentColor;
    }

    .fab {
        font-size: 28px;
        margin-right: 10px;
    }

    .fa-discord {
        position: relative;
        top: 2px;
    }

    .horizontal-list {
        list-style: none;
        padding: 0;
    }

    .donation-address {
        font-size: 14px;
        margin-bottom: 20px;
    }

    .copyright {
        font-size: 10px;
        text-align: center;
        margin-top: 40px;
        padding: 30px 0;
        border-top: 1px solid @accentColor;
    }
}

@media only screen and (max-width: 600px) {
    .footer {
        .col-sm-3 {
            padding: 0 30px;
        }
        .donation-address {
            font-size: 12px!important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/TheFooter.vue